import React, { FC } from 'react';
import Link from 'next/link';
import FieldContainer from '@common/FieldContainer';
import { ContentRouteUrl, AccaRouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './premium.module.scss';
const cx = classnames.bind(styles);

interface GuideListProps {
  isCertified: boolean;
}

const GuideList: FC<GuideListProps> = ({ isCertified }) => {
  const GuideList = () => {
    return (
      <ul className={cx('guideList')}>
        <li className={cx('guideItem')}>
          <div className={cx('text')}>역검 응시 횟수 추가 제공</div>
        </li>
        <li className={cx('guideItem')}>
          <div className={cx('text')}>심층 분석한 역검 결과지 오픈</div>
        </li>
        <li className={cx('guideItem')}>
          <div className={cx('text')}>자신있는 면접을 위한 기출 면접 연습 기능</div>
        </li>
      </ul>
    );
  };

  const CertificationGuideList = () => {
    return (
      <ul className={cx('guideList', 'certification')}>
        <li className={cx('guideItem')}>
          <Link href={AccaRouteUrl.ACCA_TEST_GATE} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('text')}>역검 응시 횟수 추가 제공</div>
            </a>
          </Link>
        </li>
        <li className={cx('guideItem')}>
          <Link href={AccaRouteUrl.ACCA_TEST_GATE} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('text')}>심층 분석한 역검 결과지 오픈</div>
            </a>
          </Link>
        </li>
        <li className={cx('guideItem')}>
          <Link href={ContentRouteUrl.PASS_INTERVIEW} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('text')}>자신있는 면접을 위한 기출 면접 연습 기능</div>
            </a>
          </Link>
        </li>
      </ul>
    );
  };

  return (
    <FieldContainer
      name={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <>
          제휴서비스
          <br />
          혜택 안내
        </>
      }
      premiumName={true}
    >
      {isCertified ? <CertificationGuideList /> : <GuideList />}
    </FieldContainer>
  );
};

export default GuideList;
